// Change YOUR_API_KEY_HERE to your apiKey
import RESTCall from "./restApi";
import moment from "moment";
// import * as XLSX from 'xlsx';
import Axios from 'axios';
import stripJsonComments from 'strip-json-comments';
// const MomentRange = require('moment-range');

const urlParams = getParamsFromUrl(window.location?.href)
const urlAssetIndex = urlParams?.includes('asset') && urlParams.indexOf('asset')
const urlAssetId = urlAssetIndex && urlParams?.[urlAssetIndex + 1]

//todo:add env
const apiAIKey = "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"
// "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"; // Replace with your actual API key
const apiPexelKey = 'tPOcC3re4a1Ks8UKrbh02pYptuGSKxZLTNoFzKHuk9mC8XyRjDyHddz4';

export const dataSource = window.location.href?.includes('https')
  ? `hexagon_pob_aa${urlAssetId ? '_' + urlAssetId : ''}`
  : `hexagon_pob_ac${urlAssetId ? '_' + urlAssetId : ''}`;

export const dataSourceAsset = window.location.href?.includes('https')
  ? `hexagon_pob_aa`
  : `hexagon_pob_ac`;
//todo:add env


//This is the production hexagon database
// export const dataSource = "hexagon_test";

export const handleLogin = async (props) => {
  const {
    email = "",
    password = "",
    deviceId
  } = props

  const hashedPassword = password //bcrypt.hashSync(password.current.value, salt) // hash created previously created upon sign up
  if (email && password) {
    const formData = {
      request: "login",
      query: {
        email: email.toLowerCase(),
        password: hashedPassword
      },
      resource: "vare_user_banking",
      id: "",
      deviceId: 'gamming'
    };
    return RESTCall.axiosQuery(formData)
      .then(response => {
        // alert(JSON.stringify(response))
        return response;
      })
      .catch(err => {
        return err &&
          err.response &&
          err.response.data &&
          err.response.data.message
      });
  }
};

export const renderSafe = (val) => {
  if (typeof val === "object") return <pre>{JSON.stringify(val)}</pre>;
  return String(val);
};


export const handleForgotPassword = async (props) => {
  const {
    email = "",
    deviceId
  } = props
  // alert(email)
  if (email) {
    const formData = {
      request: "forgetlogin",
      query: {
        email: email.toLowerCase(),
      },
      // resource: "vare_user_education",
      resource: "vare_user_education",
      id: "",
      deviceId
    };
    return RESTCall.axiosQuery(formData)
      .then(response => {
        return response;
      })
      .catch(err => {
        return err &&
          err.response &&
          err.response.data &&
          err.response.data.message
      });
  }
};

export const handleResetPassword = async (props) => {
  const {
    email = "",
    password = "",
    tempPassword = "",
    deviceId
  } = props

  const hashedPassword = password //bcrypt.hashSync(password.current.value, salt) // hash created previously created upon sign up
  if (email && password) {
    const formData = {
      request: "forgetlogin",
      query: {
        email: email.toLowerCase(),
        tempPassword: tempPassword,
        password: hashedPassword
      },
      resource: "vare_user_education",
      id: "",
      deviceId
    };
    return RESTCall.axiosQuery(formData)
      .then(response => {
        return response;
      })
      .catch(err => {
        return err &&
          err.response &&
          err.response.data &&
          err.response.data.message
      });
  }
};


export async function getUserEmail(id) {
  const formData = {
    request: "search",
    query: {
      user_id: id
    },
    resource: "vare_user_education",
    id: ""
  };
  return await RESTCall.axiosQuery(formData).then(response => {
    const data = response && response.data && response.data[0];
    return data && data.email
  });
};

export const emailBankingLoadCalc = (formData) => {
  const {
    emails = 'modupe@varetechnologies.com',
    businessName = '',
    firstName = '',
    lastName = '',
    name = '',
    email = '',
    loanAmount = ''
  } = formData;

  return {
    to: emails,
    subject: `Loan Application Received - HeritageHub Bank`,
    text: '',
    html: `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Loan Application Received</title>
      </head>
      <body style="margin: 0; padding: 0; background-color: #f4f4f4; font-family: Arial, sans-serif;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" width="600" style="border-collapse: collapse;">
          <tr>
            <td align="center" bgcolor="#004080" style="padding: 30px 0;">
              <h1 style="color: #ffffff; margin: 0;">HeritageHub Bank</h1>
            </td>
          </tr>
          <tr>
            <td bgcolor="#ffffff" style="padding: 40px 30px;">
              <h2 style="text-align: center; color: #153643;">Loan Application Confirmation</h2>
              <p style="font-size: 16px; color: #333; text-align: center;">
                Thank you ${firstName} ${lastName} for submitting your loan application.
              </p>
              <p style="font-size: 16px; color: #333; text-align: center;">
                Below is a summary of the information you provided:
              </p>
              <table width="100%" cellpadding="8" style="font-size: 14px; color: #333;">
                <tr><td><strong>Business Name:</strong></td><td>${businessName}</td></tr>
                <tr><td><strong>First Name:</strong></td><td>${name}</td></tr>
                <tr><td><strong>First Name:</strong></td><td>${email}</td></tr>
                <tr><td><strong>Email:</strong></td><td>${JSON.stringify(loanAmount)}</td></tr>
               
              </table>
              <p style="text-align: center; margin-top: 30px;">
                Our team will review your application and follow up shortly.
              </p>
              <p style="text-align: center;">
                If you have any questions, feel free to contact us at 
                <a href="mailto:support@heritagehub.com">support@heritagehub.com</a>.
              </p>
              <p style="text-align: center; margin-top: 40px;">
                Sincerely,<br/>HeritageHub Bank Team
              </p>
            </td>
          </tr>
          <tr>
            <td bgcolor="#eeeeee" style="padding: 20px; text-align: center; color: #777; font-size: 12px;">
              © ${new Date().getFullYear()} HeritageHub Bank. All rights reserved.
            </td>
          </tr>
        </table>
      </body>
      </html>
    `
  };
};


export const emailBankingMessageObject = (formData) => {
  const {
    emails = 'modupe@varetechnologies.com',
    businessName = '',
    firstName = '',
    lastName = '',
    phone = '',
    email = '',
    phoneType = 'Business',
    loanPurpose = '',
    reference = '',
    agree = false,
    homeAddress1 = '',
    homeAddress2 = '',
    city = '',
    state = 'NY',
    zip = '',
    mobilePhone = '',
    homePhone = ''
  } = formData;

  return {
    to: emails,
    subject: `Loan Application Received - HeritageHub Bank`,
    text: '',
    html: `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Loan Application Received</title>
      </head>
      <body style="margin: 0; padding: 0; background-color: #f4f4f4; font-family: Arial, sans-serif;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" width="600" style="border-collapse: collapse;">
          <tr>
            <td align="center" bgcolor="#004080" style="padding: 30px 0;">
              <h1 style="color: #ffffff; margin: 0;">HeritageHub Bank</h1>
            </td>
          </tr>
          <tr>
            <td bgcolor="#ffffff" style="padding: 40px 30px;">
              <h2 style="text-align: center; color: #153643;">Loan Application Confirmation</h2>
              <p style="font-size: 16px; color: #333; text-align: center;">
                Thank you ${firstName} ${lastName} for submitting your loan application.
              </p>
              <p style="font-size: 16px; color: #333; text-align: center;">
                Below is a summary of the information you provided:
              </p>
              <table width="100%" cellpadding="8" style="font-size: 14px; color: #333;">
                <tr><td><strong>Business Name:</strong></td><td>${businessName}</td></tr>
                <tr><td><strong>First Name:</strong></td><td>${firstName}</td></tr>
                <tr><td><strong>Last Name:</strong></td><td>${lastName}</td></tr>
                <tr><td><strong>Email:</strong></td><td>${email}</td></tr>
                <tr><td><strong>Phone:</strong></td><td>${phone} (${phoneType})</td></tr>
                <tr><td><strong>Mobile Phone:</strong></td><td>${mobilePhone}</td></tr>
                <tr><td><strong>Home Phone:</strong></td><td>${homePhone}</td></tr>
                <tr><td><strong>Loan Purpose:</strong></td><td>${loanPurpose}</td></tr>
                <tr><td><strong>Reference:</strong></td><td>${reference}</td></tr>
                <tr><td><strong>Agreement:</strong></td><td>${agree ? 'Agreed to Terms' : 'Not Agreed'}</td></tr>
                <tr><td><strong>Address:</strong></td><td>${homeAddress1}<br/>${homeAddress2}<br/>${city}, ${state} ${zip}</td></tr>
              </table>
              <p style="text-align: center; margin-top: 30px;">
                Our team will review your application and follow up shortly.
              </p>
              <p style="text-align: center;">
                If you have any questions, feel free to contact us at 
                <a href="mailto:support@heritagehub.com">support@heritagehub.com</a>.
              </p>
              <p style="text-align: center; margin-top: 40px;">
                Sincerely,<br/>HeritageHub Bank Team
              </p>
            </td>
          </tr>
          <tr>
            <td bgcolor="#eeeeee" style="padding: 20px; text-align: center; color: #777; font-size: 12px;">
              © ${new Date().getFullYear()} HeritageHub Bank. All rights reserved.
            </td>
          </tr>
        </table>
      </body>
      </html>
    `
  };
};

export const emailBankingApplicationForm = (formData) => {
  const {
    emails: myEmails,
    accountType = '',
    fullName = '',
    dob = '',
    ssnLast4 = '',
    address = '',
    cityStateZip = '',
    phone = '',
    email = '',
    idType = '',
    idNumber = '',
    issuingAuthority = '',
    issueDate = '',
    expiryDate = '',
    nomineeName = '',
    nomineeRelationship = '',
    nomineePhone = '',
    depositAmount = '',
    paymentMode = '',
    signature = '',
    declarationDate = ''
  } = formData;

  const emails = myEmails + ',info@heritagehubfederal.org'


  return {
    to: emails,
    subject: `Account Opening Form Submission - Heritage Hub FCU`,
    html: `
      <!DOCTYPE html>
      <html>
        <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Loan Application Received</title>
          <style>
            body { font-family: Arial, sans-serif; background: #f9f9f9; padding: 20px; color: #333; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
            th, td { border: 1px solid #ccc; padding: 10px; vertical-align: top; }
            th { background: #eee; text-align: left; width: 35%; }
            h2 { text-align: center; color: #004080; }
            .section-title { background: #ddd; font-weight: bold; padding: 10px; }
          </style>
        </head>
        <body>
          <h2>Heritage Hub Federal Credit Union<br/>Account Opening Form</h2>

          <div class="section-title">SECTION 1: ACCOUNT TYPE</div>
          <table>
            <tr><th>Account Type Selected</th><td>${accountType}</td></tr>
            <tr><th>Membership Fee</th><td>$5</td></tr>
          </table>

          <div class="section-title">SECTION 2: PERSONAL INFORMATION</div>
          <table>
            <tr><th>Full Name</th><td>${fullName}</td></tr>
            <tr><th>Date of Birth</th><td>${dob}</td></tr>
            <tr><th>Last 4 of Social</th><td>${ssnLast4}</td></tr>
            <tr><th>Address</th><td>${address}</td></tr>
            <tr><th>City, State, Zip</th><td>${cityStateZip}</td></tr>
            <tr><th>Phone Number</th><td>${phone}</td></tr>
            <tr><th>Email</th><td>${email}</td></tr>
          </table>

          <div class="section-title">SECTION 3: IDENTIFICATION DETAILS</div>
          <table>
            <tr><th>Type of ID</th><td>${idType}</td></tr>
            <tr><th>ID Number</th><td>${idNumber}</td></tr>
            <tr><th>Issuing Authority</th><td>${issuingAuthority}</td></tr>
            <tr><th>Issue Date</th><td>${issueDate}</td></tr>
            <tr><th>Expiry Date</th><td>${expiryDate}</td></tr>
          </table>

          <div class="section-title">SECTION 4: NOMINEE DETAILS (WHO CAN ACT ON YOUR BEHALF)</div>
          <table>
            <tr><th>Nominee Name</th><td>${nomineeName}</td></tr>
            <tr><th>Relationship</th><td>${nomineeRelationship}</td></tr>
            <tr><th>Phone Number</th><td>${nomineePhone}</td></tr>
          </table>

          <div class="section-title">INITIAL DEPOSIT</div>
          <table>
            <tr>
              <th>Instructions</th>
              <td>
                BJT Services, Zelle 832-353-6109<br/>
                Transfer to: Chase Bank<br/>
                Account Number: 939051733<br/>
                Routing Number: 111000614<br/>
                Memo: HHFCU
              </td>
            </tr>
            <tr><th>Deposit Amount</th><td>$${depositAmount}</td></tr>
            <tr><th>Mode of Payment</th><td>${paymentMode}</td></tr>
          </table>

          <div class="section-title">DECLARATION</div>
          <table>
            <tr>
              <td colspan="2">
                I hereby confirm the information provided above is true.
                I agree to abide by the terms and conditions of the Heritage Hub Federal Credit Union.
              </td>
            </tr>
            <tr><th>Signature</th><td>${signature}</td></tr>
            <tr><th>Date</th><td>${declarationDate}</td></tr>
          </table>

          <div class="section-title">FOR OFFICIAL USE</div>
          <table>
            <tr><th>Account Number</th><td>_____________________</td></tr>
            <tr><th>Date Opened</th><td>_____________________</td></tr>
            <tr><th>Approved By</th><td>_____________________</td></tr>
            <tr><th>Signature</th><td>_____________________</td></tr>
          </table>

          <p style="text-align: center; font-size: 12px; color: #888;">
            © ${new Date().getFullYear()} Heritage Hub FCU. All rights reserved.
          </p>
        </body>
      </html>
    `
  };
};


export const emailBookNowForm = (formData) => {
  const {
    name = '',
    email = '',
    phone = '',
    availableDate = '',
    emails
  } = formData;

  return {
    to: emails + ',info@heritagehubfederal.org',
    subject: `New Booking Request Received`,
    html: `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Booking Request</title>
          <style>
            body { font-family: Arial, sans-serif; background: #f9f9f9; padding: 20px; color: #333; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ccc; padding: 10px; text-align: left; vertical-align: top; }
            th { background-color: #eee; width: 30%; }
            h2 { text-align: center; color: #004080; }
          </style>
        </head>
        <body>
          <h2>Heritage Hub FCU<br/>Booking Request Form</h2>

          <table>
            <tr><th>Full Name</th><td>${name}</td></tr>
            <tr><th>Email</th><td>${email}</td></tr>
            <tr><th>Phone Number</th><td>${phone}</td></tr>
            <tr><th>Available Date</th><td>${availableDate}</td></tr>
          </table>

          <p style="text-align: center; font-size: 12px; color: #888;">
            © ${new Date().getFullYear()} Heritage Hub FCU. All rights reserved.
          </p>
        </body>
      </html>
    `
  };
};






export const modifyDataModel = async ({ text, dataModel }) => {
  const apiKey = apiAIKey; // Securely load from environment
  const CHATGPT_API_URL = "https://api.openai.com/v1/chat/completions";

  if (!apiKey) {
    throw new Error("API key is required.");
  }

  const prompt = `
  Redefine the "${text}" text into a specific industry. 
  - Modify the given data model to match the "${text}" description.
  - Adjust all text except for images and videos to be relevant to "${text}".
  - Replace all game-related titles, headers, and descriptions.
  - Ensure all links and menu items are industry-specific.
  - Keep structure intact but adapt the content.

  Input Data Model:
  ${JSON.stringify(dataModel, null, 2)}

  Respond ONLY with a valid JSON object with {result, industry}, and no other text. result being the object and industry a string.
`;

  try {
    const response = await Axios.post(
      CHATGPT_API_URL,
      {
        model: "gpt-4",
        messages: [{ role: "user", content: prompt }],
        temperature: 0.7,
        max_tokens: 2000
      },
      {
        headers: {
          Authorization: `Bearer ${apiKey}`,
          "Content-Type": "application/json",
        },
        timeout: 90000,
      }
    );

    let modifiedData = response.data.choices[0]?.message?.content.trim();

    // Remove markdown code wrapping if present
    if (modifiedData.startsWith("```json")) {
      modifiedData = modifiedData.replace(/^```json/, "").replace(/```$/, "").trim();
    }

    try {
      modifiedData = JSON.parse(stripJsonComments(modifiedData));
    } catch (e) {
      console.error("Failed to parse modified data:", modifiedData);
      throw new Error("Invalid JSON returned by OpenAI.");
    }

    const { result, industry } = modifiedData;
    return await updateImagesWithPexels(result, industry);
  } catch (error) {
    console.error("Error modifying data model:", error);
    throw new Error("Failed to modify data model.");
  }
};

// export const countWords = (text) => {
//   return typeof text === 'string'
//     ? text.trim().split(/\s+/).length
//     : 0;
// };

export const handleFontAwesomeRedirect = () => {
  const confirm = window.confirm(
    "Confirm that you'll like to go to Font Awesome website to find the appropriate icon for your need"
  );

  if (confirm) {
    window.open('https://fontawesome.com/search', '_blank');
  }
};

export const countWords = (text) => {
  return typeof text === 'string'
    ? text.trim().split(/\s+/).length
    : String(text || '').trim().split(/\s+/).length;
};

export const modifyTextAI = async ({ text, length = 20 }) => {
  if (!text || typeof text !== 'string') return '';

  const prompt = `If the following text includes a task, perform the task. Otherwise, improve clarity, grammar, and tone. Keep it under ${length} words: "${text}"`;

  try {
    const response = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY || apiAIKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: "gpt-4",
        messages: [{ role: "user", content: prompt }],
        temperature: 0.7,
      }),
    });

    const data = await response.json();
    return data.choices?.[0]?.message?.content?.trim() || '';
  } catch (error) {
    console.error("modifyTextAI error:", error);
    return '';
  }
};




async function updateImagesWithPexels(data, industry) {
  const PEXELS_API_KEY = apiPexelKey; //process.env.PEXELS_API_KEY;
  const PEXELS_API_URL = "https://api.pexels.com/v1/search";

  const fallbackKeywords = [
    `${industry} site`,
    `${industry} equipment`,
    `${industry} team`,
    `${industry} tools`
  ];

  async function fetchPexelsImagesBatch(queries, perQuery = 4) {
    const images = [];
    for (const query of queries) {
      try {
        const response = await Axios.get(PEXELS_API_URL, {
          headers: { Authorization: PEXELS_API_KEY },
          params: { query, per_page: perQuery },
          timeout: 10000,
        });
        const urls = response.data.photos.map((photo) => photo.src.large);
        images.push(...urls);
      } catch (error) {
        console.error(`Error fetching images for query '${query}':`, error);
      }
    }
    return images;
  }

  async function replaceImages(obj, images, imageIndex) {
    for (const key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        imageIndex = await replaceImages(obj[key], images, imageIndex);
      } else if (
        typeof obj[key] === "string" &&
        (
          key.toLowerCase().includes("image") ||
          key.toLowerCase().includes("img") ||
          key.toLowerCase().includes("src") ||
          /\.(jpe?g|png|webp)$/i.test(obj[key])
        )
      ) {
        if (images[imageIndex]) {
          obj[key] = images[imageIndex];
          imageIndex++;
        }
      }
    }
    return imageIndex;
  }

  const imageList = await fetchPexelsImagesBatch(fallbackKeywords, 4);
  await replaceImages(data, imageList, 0);
  return data;
}





export const jumpToReleventDiv = (id) => {
  const releventDiv = document.getElementById(id);
  // behavior: "smooth" parameter for smooth movement
  releventDiv?.scrollIntoView({ behavior: "smooth" });
};



export const getPictureByDescription = async (props) => {
  const {
    description,
    myInfo
  } = props

  if (!myInfo?.handle) {
    return
  }

  const url = `https://api.pexels.com/v1/search?query=${encodeURIComponent(description)}&per_page=10`;

  const result = await getDataDB({
    query: {
      description,
    },
    resource: `gaming_pexels_search_result`,
  })

  if (result?.[0]) {
    return result
  }


  return await fetch(url, {
    headers: {
      Authorization: 'tPOcC3re4a1Ks8UKrbh02pYptuGSKxZLTNoFzKHuk9mC8XyRjDyHddz4'
    }
  }).then(async (resp) => {
    console.log('Status:', resp.status);
    const json = await resp.json();
    console.log('Response:', json);
    return json;
  })
    .then(async (pics) => {
      await saveDataDB({
        query: {
          description,
          pictures: pics?.photos,
          date: moment()
        },
        resource: `gaming_pexels_search_result`,
        keys: ["description"],
      });

      return pics?.photos;
    })
    .catch(err => {
      console.error('Error fetching from Pexels:', err);
      alert('Fetch error: ' + err.message);
      return [];
    });

}

export const isDescriptionField = (key) => {
  if (!key || typeof key !== 'string') return false;

  const lowerKey = key.toLowerCase();

  const blockedKeywords = [
    'email', 'phone', 'contact', 'address',
    'name', 'url', 'link', 'website',
    'date', 'time', 'id',
  ];

  const aiFriendlyKeywords = [
    'desc', 'bio', 'summary', 'note', 'text',
    'content', 'details', 'description', 'title',
    'mission', 'goal', 'why', 'how', 'vision'
  ];

  const isBlocked = blockedKeywords.some(term => lowerKey.includes(term));
  const isTargeted = aiFriendlyKeywords.some(term => lowerKey.includes(term));

  return !isBlocked && isTargeted;
};


// export const isDescriptionField = (key) => {
//   if (key && typeof key === 'string') {
//     const lowerKey = key.toLowerCase();
//     return (
//       !lowerKey.includes("email") &&
//       !lowerKey.includes("phone") &&
//       !lowerKey.includes("contact") &&
//       !lowerKey.includes("address") &&
//       !lowerKey.includes("name") &&
//       !lowerKey.includes("url") &&
//       !lowerKey.includes("link") &&
//       !lowerKey.includes("website") &&
//       !lowerKey.includes("date") &&
//       !lowerKey.includes("time") &&
//       !lowerKey.includes("id") &&
//       (
//         lowerKey.includes("desc") ||
//         lowerKey.includes("bio") ||
//         lowerKey.includes("summary") ||
//         lowerKey.includes("note") ||
//         lowerKey.includes("text") ||
//         lowerKey.includes("content") ||
//         lowerKey.includes("details") ||
//         lowerKey.includes("description") ||
//         lowerKey.includes("title")
//       )
//     );
//   }
//   return false;
// };

export const isImageField = (key) => {
  if (key && typeof key == 'string')
    return (
      key?.toLowerCase().includes("image") ||
      key?.toLowerCase().includes("img") ||
      key?.toLowerCase().includes("src") ||
      key?.toLowerCase() == "thumb" ||
      key?.toLowerCase() == "full" ||
      key?.toLowerCase() == "logo" ||
      key?.toLowerCase() == "photo"
      // key?.toLowerCase() == "icon"
    );
};

const createImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.setAttribute("crossOrigin", "anonymous"); // Avoid CORS issues
    img.src = url;
  });
};


export const getCroppedImg = async (props) => {
  const {
    imageSrc, crop
  } = props
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = crop.width;
  canvas.height = crop.height;

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        console.error("Canvas is empty");
        return reject();
      }
      blob.name = "croppedImage.jpeg";
      const fileUrl = window.URL.createObjectURL(blob);
      resolve(fileUrl);
    }, "image/jpeg");
  });
};



export const handlePredefinedRange = async (props) => {
  const { range } = props
  let startDate = "";
  let endDate = "";

  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yy = String(today.getFullYear()).slice(-2); // Get last two digits of the year
  const currentDate = `${mm}/${dd}/${yy}`;

  switch (range) {
    case "Tomorrow":
      startDate = currentDate;
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() + 1);
      endDate = `${String(yesterday.getMonth() + 1).padStart(
        2,
        "0"
      )}/${String(yesterday.getDate()).padStart(2, "0")}/${String(
        yesterday.getFullYear()
      ).slice(-2)}`;
      break;
    case "Next 7 days":
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() + 7);
      endDate = `${String(sevenDaysAgo.getMonth() + 1).padStart(
        2,
        "0"
      )}/${String(sevenDaysAgo.getDate()).padStart(2, "0")}/${String(
        sevenDaysAgo.getFullYear()
      ).slice(-2)}`;
      startDate = currentDate;
      break;
    case "Next 30 days":
      const thirtyDaysAgo = new Date(today);
      thirtyDaysAgo.setDate(today.getDate() + 30);
      endDate = `${String(thirtyDaysAgo.getMonth() + 1).padStart(
        2,
        "0"
      )}/${String(thirtyDaysAgo.getDate()).padStart(2, "0")}/${String(
        thirtyDaysAgo.getFullYear()
      ).slice(-2)}`;
      startDate = currentDate;
      break;
    case "This month":
      startDate = `${mm}/01/${yy}`;
      endDate = currentDate;
      break;
    case "Next month":
      const nextMonthFirstDate = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1
      );
      const nextMonthLastDate = new Date(
        today.getFullYear(),
        today.getMonth() + 2,
        0
      ); // Note the +2 for the next month
      startDate = `${String(nextMonthFirstDate.getMonth() + 1).padStart(
        2,
        "0"
      )}/01/${String(nextMonthFirstDate.getFullYear()).slice(-2)}`;
      endDate = `${String(nextMonthLastDate.getMonth() + 1).padStart(
        2,
        "0"
      )}/${String(nextMonthLastDate.getDate()).padStart(2, "0")}/${String(
        nextMonthLastDate.getFullYear()
      ).slice(-2)}`;
      break;

    default:
      break;
  }

  // console.log("vvvbxxx", startDate, endDate);
  return {
    endDate,
    startDate
  }

};

export const handleCustomEndRangeChange = async (props) => {
  const { event } = props
  const [year, month, day] = event.target.value.split("-")

  const formattedDate = [
    month.padStart(2, "0"),
    day.padStart(2, "0"),
    year.slice(-2),
  ].join("/")
  // setEndDate(formattedDate);
  return formattedDate;
};

export const handleCustomStartRangeChange = async (props) => {
  const { event } = props
  const [year, month, day] = event.target.value.split("-");

  const formattedDate = [
    month.padStart(2, "0"),
    day.padStart(2, "0"),
    year.slice(-2),
  ].join("/");
  // setStartDate(formattedDate);
  return formattedDate

};


export const dataLine = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
  datasets: [
    {
      label: "First dataset",
      data: [33, 53, 85, 41, 44, 65],
      fill: true,
      backgroundColor: "rgba(75,192,192,0.2)",
      borderColor: "rgba(75,192,192,1)",
    },
    {
      label: "Second dataset",
      data: [33, 25, 35, 51, 54, 76],
      fill: true,
      backgroundColor: "#742774",
      borderColor: "#742774",
    },
  ],
};

export const monthsArray = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const colors = [
  "#FF6633",
  "#FFB399",
  "#FF33FF",
  "#FFFF99",
  "#00B3E6",
  "#E6B333",
  "#3366E6",
  "#999966",
  "#99FF99",
  "#B34D4D",
  "#80B300",
  "#809900",
  "#E6B3B3",
  "#6680B3",
  "#66991A",
  "#FF99E6",
  "#CCFF1A",
  "#FF1A66",
  "#E6331A",
  "#33FFCC",
  "#66994D",
  "#B366CC",
  "#4D8000",
  "#B33300",
  "#CC80CC",
  "#66664D",
  "#991AFF",
  "#E666FF",
  "#4DB3FF",
  "#1AB399",
  "#E666B3",
  "#33991A",
  "#CC9999",
  "#B3B31A",
  "#00E680",
  "#4D8066",
  "#809980",
  "#E6FF80",
  "#1AFF33",
  "#999933",
  "#FF3380",
  "#CCCC00",
  "#66E64D",
  "#4D80CC",
  "#9900B3",
  "#E64D66",
  "#4DB380",
  "#FF4D4D",
  "#99E6E6",
  "#6666FF",
];

export function pushUnique(props) {
  const { arr, newElement, key1, key2 } = props
  if (!(arr && newElement && key1 && key2)) {
    return []
  }
  // Check if the new element already exists in the array based on the two keys
  const exists = arr.some(item => item[key1] === newElement[key1] && item[key2] === newElement[key2]);

  // If it does not exist, push the new element into the array
  if (!exists) {
    arr.push(newElement);
  }

  return arr;
}

export const groupByAndGetKeys = ({ data, groupByKey }) => {
  if (!Array.isArray(data) || data.length === 0) {
    console.error("Invalid dataset: Must be a non-empty array.");
    return [];
  }

  if (!groupByKey || typeof groupByKey !== "string") {
    console.error("Invalid groupByKey: Must be a string.");
    return [];
  }

  const groupedData = data.reduce((acc, item) => {
    const key = item[groupByKey];
    if (key) {
      acc[key] = acc[key] || [];
      acc[key].push(item);
    }
    return acc;
  }, {});

  return Object.keys(groupedData);
};

export const groupByAndGetObjects = ({ data, key: groupByKey, id }) => {
  if (!Array.isArray(data) || data.length === 0) {
    console.error("Invalid dataset: Must be a non-empty array.");
    return [];
  }

  if (!groupByKey || typeof groupByKey !== "string") {
    console.error("Invalid groupByKey: Must be a string.");
    return [];
  }

  const groupedData = data.reduce((acc, item) => {
    const key = item[groupByKey];
    if (key) {
      acc[key] = acc[key] || [];
      acc[key].push(item);
    }
    return acc;
  }, {});

  return groupedData;
};



export function addUniqueElement(props) {
  const { arr, element } = props
  // Check if the element already exists in the array
  if (!arr.includes(element)) {
    arr.push(element); // Add element if it doesn't exist
  }
  return arr; // Return the updated array
}

// export function groupByNow({ data, key, id }) {
//   if (!(data && data?.length > 0 && key) || !key) {
//     return {};
//   }
//   let group =
//     key &&
//     data &&
//     Array.isArray(data) &&
//     data.reduce((r, a) => {
//       if (!a?.[key]) {
//         return {}
//       }
//       r[a[key]] = [...(r[a[key]] || []), a];
//       return r;
//     }, {});
//   return group;
// }

// export const groupByKeys = ({
//   data,
//   key1,
//   key2 = null,
//   key3 = null,
//   key4 = null
// }) => {
//   if (!Array.isArray(data) || data.length === 0) {
//     console.error("Invalid dataset: Must be a non-empty array.");
//     return {};
//   }

//   if (!key1 || typeof key1 !== "string") {
//     console.error("Invalid first-level key: Must be a valid string.");
//     return {};
//   }

//   return data.reduce((acc, item) => {
//     const level1 = item[key1];
//     const level2 = key2 ? item[key2] : null;
//     const level3 = key3 ? item[key3] : null;
//     const level4 = key4 ? item[key4] : null;

//     if (!level1) return acc;

//     // Ensure first-level group exists
//     if (!acc[level1]) acc[level1] = {};

//     if (key2 && level2) {
//       // Ensure second-level group exists
//       if (!acc[level1][level2]) acc[level1][level2] = {};

//       if (key3 && level3) {
//         // Ensure third-level group exists
//         if (!acc[level1][level2][level3]) acc[level1][level2][level3] = {};

//         if (key4 && level4) {
//           // Ensure fourth-level group exists
//           if (!acc[level1][level2][level3][level4]) acc[level1][level2][level3][level4] = [];
//           acc[level1][level2][level3][level4].push(item);
//         } else {
//           acc[level1][level2][level3].push(item);
//         }
//       } else {
//         acc[level1][level2].push(item);
//       }
//     } else {
//       acc[level1].push(item);
//     }

//     return acc;
//   }, {});
// };

export const groupByKeys = ({ data, key1, key2 = null, key3 = null, key4 = null }) => {
  if (!Array.isArray(data) || data.length === 0) {
    console.error("Invalid dataset: Must be a non-empty array.");
    return {};
  }

  if (!key1 || typeof key1 !== "string") {
    console.error("Invalid first-level key: Must be a valid string.");
    return {};
  }

  return data.reduce((acc, item) => {
    const level1 = item[key1];
    const level2 = key2 ? item[key2] : null;
    const level3 = key3 ? item[key3] : null;
    const level4 = key4 ? item[key4] : null;

    if (!level1) return acc;

    // Ensure first-level group exists
    if (!acc[level1]) acc[level1] = key2 ? {} : [];

    if (key2 && level2) {
      // Ensure second-level group exists
      if (!acc[level1][level2]) acc[level1][level2] = key3 ? {} : [];

      if (key3 && level3) {
        // Ensure third-level group exists
        if (!acc[level1][level2][level3]) acc[level1][level2][level3] = key4 ? {} : [];

        if (key4 && level4) {
          // Ensure fourth-level group exists as an array
          if (!acc[level1][level2][level3][level4]) acc[level1][level2][level3][level4] = [];
          acc[level1][level2][level3][level4].push(item);
        } else {
          acc[level1][level2][level3].push(item);
        }
      } else {
        acc[level1][level2].push(item);
      }
    } else {
      acc[level1].push(item);
    }

    return acc;
  }, {});
};






export const groupByNow = ({ data, key: groupByKey, id }) => {
  if (!Array.isArray(data) || data.length === 0) {
    // console.error("Invalid dataset: Must be a non-empty array.");
    return [];
  }

  if (!groupByKey || typeof groupByKey !== "string") {
    // console.error("Invalid groupByKey: Must be a string.");
    return [];
  }

  const groupedData = data.reduce((acc, item) => {
    const key = item[groupByKey];
    if (key) {
      acc[key] = acc[key] || [];
      acc[key].push(item);
    }
    return acc;
  }, {});

  return groupedData;
};


export const optionChecker = ({ openedTable, item, formInput }) => {
  if (
    openedTable == "schedule" &&
    item?.table != "project" &&
    !formInput?.projectId
  ) {
    return "Please select Project to continue";
  }
  if (
    openedTable == "schedule" &&
    item?.table == "utility" &&
    !formInput?.facilityId
  ) {
    return "Please select facility to continue";
  }
  if (
    openedTable == "schedule" &&
    item?.table == "person" &&
    !(formInput?.dates?.length > 0 && formInput?.days?.length > 0)
  ) {
    return "Please select dates before person so you dont double book";
  }
  return false;
};

export function dedupeDates(props) {
  const { dates } = props
  const uniqueDates = [];

  for (const date of dates) {
    const formattedDate = moment(date)?.format("MM/DD/YY");
    if (!uniqueDates.includes(formattedDate)) {
      uniqueDates.push(formattedDate);
    }
  }

  return uniqueDates.map(date => moment(date));
}

export function removeDuplicateObjects(props) {
  const {
    arr, key
  } = props
  const seen = new Set();
  return arr.filter(item => {
    const value = item[key];
    if (seen.has(value)) {
      return false;
    } else {
      seen.add(value);
      return true;
    }
  });
}

export const capitalizeInfo = (word) => {
  // const { word } = props
  const firstLetter = word.charAt(0);

  const firstLetterCap = firstLetter.toUpperCase();

  const remainingLetters = word.slice(1);
  return "firstLetterCap + remainingLetters";
};



export const resizeImage = async ({
  image: base64Str,
  width: maxWidth = 400,
  height: maxHeight = 350
}) => {
  return new Promise((resolve) => {
    let img = new Image();
    img.src = base64Str;
    img.onload = () => {
      let canvas = document.createElement("canvas");
      const MAX_WIDTH = maxWidth;
      const MAX_HEIGHT = maxHeight;
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext("2d");
      ctx?.drawImage(img, 0, 0, width, height);
      return resolve(canvas.toDataURL());
    };
  });
};

export const myColors = {
  brown: "#617d98", //'#ba5d2c',
  red: "#c70039",
  gray: "#617d98",
};




export function renameKeysInArray(props) {
  const {
    arr, keyMapping
  } = props
  return arr.map(obj => {
    const newObj = {};
    Object.keys(obj).forEach(key => {
      if (keyMapping[key]) {
        newObj[keyMapping[key]] = obj[key];
      }
    });
    return newObj;
  });
}






export function changeObjectKeys(props) {
  const {
    obj, keyMap
  } = props
  // Create a new object to hold the transformed key-value pairs
  const newObj = {};

  // Iterate over the keys of the original object
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      // Check if the key exists in the keyMap
      const newKey = keyMap[key] || key; // Use the new key if mapped, otherwise keep the original key
      // Assign the value to the new key in the new object
      newObj[newKey] = obj[key];
    }
  }

  return newObj;
}

export function arraysEqual(props) {
  const {
    arr1, arr2
  } = props
  if (arr1?.length !== arr2?.length) {
    return false;
  }

  let sortedArr1 = arr1.slice().sort();
  let sortedArr2 = arr2.slice().sort();

  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) {
      return false;
    }
  }

  return true;
}

export function isSubset(props) {
  const {
    arr1, arr2
  } = props
  return arr1.every(element => arr2.includes(element));
}

export const handleRegister = async (props) => {
  const { fullName, email, password } = props;

  // console.log(props, "props");

  if (
    fullName == "" ||
    email == "" ||
    password == "" ||
    // myPWRef.current.value == "" ||
    // isValidPhone(myPhoneRef.current.value) == false ||
    validateEmail(email) == false
  ) {
    alert("Please be sure to complete all fields");
    return;
  }
  return addRegister(props);
};

const validateEmail = (mail) => {
  if (mail?.includes("@")) {
    return true;
  }
  alert("You have entered an invalid email address!");
  return false;
};

export const addRegister = async (props) => {
  const formData = {
    request: "register",
    query: {
      name: props?.fullName,
      user_id: props?.handle,
      ...props,
    },
    resource: "vare_user_banking",
    check: ["email"],
    // check: ["handle", "email"],
  };
  // alert(JSON.stringify(formData))
  return await RESTCall.axiosQuery(formData)
    .then((response) => {
      // alert(JSON.stringify(formData))

      return response;
    })
    .catch((error) => {
      console.log("error", error);
      return error;
    });
};



var CLIENT_ID =
  "736539225825-mo62ta57dtlpr8luak2mdt9ieo1iqrpr.apps.googleusercontent.com";
var API_KEY = "AIzaSyA2ynyIIS__xCDklZgWEoZcDZMsCml9ruQ";
var DISCOVERY_DOCS = [
  "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
];
var SCOPES = "https://www.googleapis.com/auth/calendar.events";
const request = "";
// const client = createClient('tPOcC3re4a1Ks8UKrbh02pYptuGSKxZLTNoFzKHuk9mC8XyRjDyHddz4');

const urlPrefix = "/";

export async function saveDataDB(props) {
  const { resource, query, keys, myInfo = {} } = props;
  const { eventInfo } = myInfo;
  if (!(resource && query)) {
    return;
  }

  const report = [...keys]?.filter(res => {
    return Object.keys(query)?.includes(res)
  })
  if (report?.length != keys?.length) {
    console.log('Key is missing in dataset')
    return
  }

  if (keys?.includes('_id') && keys?.length > 0) delete query?._id;
  const formData = {
    request: "insert",
    query: {
      ...query,
      updatedDate: moment().format(),
    },
    resource: resource,
    ...(keys ? { check: keys } : {}),
  };
  return await RESTCall.axiosQuery(formData)
    .then((response) => {
      return (response && response.data) || [];
    })
    .catch((error) => {
      return error;
    });
}



export function getCommonElements(props) {
  const {
    arr1, arr2
  } = props
  const set1 = new Set(arr1);

  for (const element of arr2) {
    if (set1.has(element)) {
      return [element];
    }
  }

  return null; // Return null if no common element is found
}


// export function processExcelFile(props) {
//   const { file } = props
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.onload = (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: 'array' });

//       // Get the first sheet
//       const sheet = workbook.Sheets[workbook.SheetNames[0]];

//       // Convert the sheet to JSON
//       let jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//       // Step 1: Use row 5 as header and format columns after J as 'MM/DD/YYYY'
//       const headers = jsonData[5];
//       headers.forEach((header, index) => {
//         if (index > 9) {  // After column J (index 9)
//           headers[index] = XLSX.SSF.format('MM/DD/YYYY', new Date(header));
//         } else {
//           headers[index] = header
//         }
//       });
//       // console.log('jsonData', headers)


//       // Step 2: Delete rows before row 5 and rows where column H is empty
//       jsonData = jsonData.slice(4).filter(row => row[7] !== undefined && row[7] !== null && row[7] !== '');

//       // Step 3: Remove all rows where column C ends (assuming after column C, all values are empty)
//       jsonData = jsonData.filter(row => row[2] !== undefined && row[2] !== null && row[2] !== '');


//       // Step 5: Replace row values after column J that are "x", "on", "X", "off", "OFF", "ON"
//       jsonData.forEach(row => {
//         for (let i = 9; i < row.length; i++) { // After column J
//           if (["x", "on", "X", "off", "OFF", "ON"].includes(row[i])) {
//             row[i] = headers[i] // Replace with the corresponding header
//           }
//         }
//       });
//       jsonData.forEach(row => {
//         for (let i = 0; i < 9; i++) { // After column J
//           row[i] = row[i]  // Replace with the corresponding header
//         }
//       });

//       // Step 4: Delete column A
//       jsonData.forEach(row => row.shift());


//       // console.log('jsonData', jsonData)
//       // Step 6: Combine data from column J and after into 1 column called dates
//       const combinedData = jsonData.map(row => {
//         const baseData = row.slice(0, 9);  // Columns A to I
//         const dateValues = row.slice(9);   // Columns J and after
//         const combinedDates = dateValues.filter(val => val !== null && val !== undefined);
//         return [...baseData, combinedDates.join(", ")];
//       });

//       // Step 7: Convert to array of objects
//       const result = combinedData.map(row => {
//         const obj = {};
//         headers.slice(0, 9).forEach((key, index) => {  // Use headers from columns B to I
//           // console.log('jsonDataxx', key, row)
//           obj[key.split(" ")[0]] = row[index];  // Use the first word in the header name as key
//         });
//         obj["dates"] = row[9];  // Add the combined dates column
//         return obj;
//       });

//       resolve(result);
//     };

//     reader.onerror = (error) => reject(error);
//     reader.readAsArrayBuffer(file);
//   });
// }





// export async function confirmMessage(text) {
//   // let text = "Press a button!\nEither OK or Cancel.";
//   if (confirm(text) == true) {
//     text = "You pressed OK!";
//   } else {
//     text = "You canceled!";
//   }
//   document.getElementById("demo").innerHTML = text;
// }

export const getDataByDateRange = async (props) => {
  const { firstDate, lastDate, tables } = props;

  const daterangeInfo = getDateRange({
    firstDate,
    lastDate,
  });

  // console.log('daterangeInfo', daterangeInfo)
  const ids = [];
  const schedules = [];

  await Promise.all(
    daterangeInfo?.map(async (date) => {
      return await getDataWildArrayDB({
        key: "dates",
        request: "wildsearchArray",
        searchVal: date, //'04/15/24',
        resource: `${dataSource}_schedule`,
        // limit: 50,
        // skip: 0,
      }).then(async (report) => {
        // console.log('schedulesxx6777', date, groupActivityByUtility)
        const scheduleInfo = await handleTable({
          schedules: report,
          tables,
        });
        scheduleInfo?.map((ref) => {
          schedules.push({
            ...ref,
            date,
          });
        });
      });
    })
  );

  return {
    dataArray: schedules,
    daterangeInfo: daterangeInfo,
  };
};

export const handleTable = async ({ schedules, tables }) => {
  let recordEndDate = moment();
  let recordStartDate = moment();
  const detail = await Promise.all(
    schedules?.map(async (schedule) => {
      const addresses = {};

      const shift = tables?.shift?.filter((res) => {
        return schedule?.shiftId == res?._id;
      })?.[0]?.name;

      const asset = tables?.asset?.filter((res) => {
        return schedule?.assetId == res?._id;
      })?.[0]?.name;

      const company = tables?.company?.filter((res) => {
        return schedule?.companyId == res?._id;
      })?.[0]?.name;

      const utilityObject = tables?.utility?.filter((res) => {
        return schedule?.utilityId == res?._id;
      })?.[0];

      addresses["utility"] = utilityObject?.address;
      const utility = utilityObject?.name || "";
      const utilityTypeId = utilityObject?.utilityTypeId;

      const allUtilityTypes = tables?.utilityType?.filter((res) => {
        return schedule?.utilityTypeId == res?._id;
      })?.[0];

      const utilityTypeName = allUtilityTypes?.name;

      const facilityObject = tables?.facility?.filter((res) => {
        return schedule?.facilityId == res?._id;
      })?.[0];

      addresses["facility"] = facilityObject?.address;

      const facility = facilityObject?.name;
      const facilityId = facilityObject?._id;
      const utilityCapacity = facilityObject?.utilityTypeId?.[utilityTypeId];

      const projectObject = tables?.project?.filter((res) => {
        return schedule?.projectId == res?._id;
      })?.[0];
      addresses["project"] = projectObject?.address;
      const project = projectObject?.name;

      const personList = tables?.person?.filter((res) => {
        return schedule?.personId == res?._id &&
          Array.isArray(schedule?.personId)
          ? schedule?.personIds?.[0]
          : schedule?.personIds;
      })?.[0];

      const person = personList?.name; //&& JSON.stringify(personList)?.replace(',', "99")?.replace(/[^\w.]|_/g, " ")?.replace(' 99 ', ",")
      const sex = personList?.sex;

      const scheduleDateRange = [];
      const scheduleDates = [];

      schedule?.dates?.map((date) => {
        // console.log("freeresult-date", date);

        if (!scheduleDates?.includes(date)) {
          scheduleDates.push(date);
          recordEndDate =
            moment(recordEndDate).diff(moment(date)) > 0
              ? moment(recordEndDate)
              : moment(date);
          recordStartDate =
            moment(recordStartDate).diff(moment(date)) < 0
              ? moment(recordStartDate)
              : moment(date);
        }
      });

      if (!scheduleDateRange?.includes(schedule?.start)) {
        scheduleDateRange.push(schedule?.start);
      }
      if (!scheduleDateRange?.includes(schedule?.end)) {
        scheduleDateRange.push(schedule?.end);
      }

      const sortedDates = scheduleDateRange.sort(function (a, b) {
        // Convert the date strings to Date objects
        let dateA = new Date(a);
        let dateB = new Date(b);

        // Subtract the dates to get a value that is either negative, positive, or zero
        return dateA - dateB;
      });

      const start = sortedDates?.[0];
      const end = sortedDates?.[sortedDates?.length - 1];

      return {
        ...schedule,
        asset,
        company,
        project,
        facility,
        person,
        sex,
        shift,
        utility,
        utilityTypeId,
        request: 1,
        capacity: utilityCapacity,
        utilityCapacity,
        utilityTypeName,
        facilityId,
        // scheduleType: 'TBD',
        complement: "asasasww11",
        // company: getInfo?.company?.[0]?.name || "",
        img: "https://varefiles.s3.us-east-2.amazonaws.com/meetingpic2.jpg",
        start: start,
        end: end,
        dates: scheduleDates || [],
        id: schedule?._id,
        schedule: schedule?.name,
        type: "schedule",
        progress: 45,
        isDisabled: true,
        addresses,
        address: addresses?.facility,
      };
    })
  );

  return detail;
};

export function isPointInPolygon(props) {
  const {
    point = [37.7749, -122.4194],
    polygon = [
      [37.7833, -122.4167], // Point 1
      [37.7833, -122.4067], // Point 2
      [37.7733, -122.4067], // Point 3
      [37.7733, -122.4167]  // Point 4
    ]
  } = props
  const [x, y] = point;
  let inside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [xi, yi] = polygon[i];
    const [xj, yj] = polygon[j];

    const intersect = ((yi > y) !== (yj > y)) &&
      (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }

  return inside;
}

// export function getRecurringDatesWeekly(props) {
//   const {
//     initialDates, endDate
//   } = props
//   // Convert endDate to a Date object
//   const end = new Date(endDate);
//   const recurringDates = [];

//   // Helper function to add days to a date
//   const addDays = (date, days) => {
//     const result = new Date(date);
//     result.setDate(result.getDate() + days);
//     return result;
//   };

//   // Helper function to format date as YYYY-MM-DD
//   const formatDate = (date) => {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   // Loop through each initial date
//   initialDates.forEach((initialDate) => {
//     let current = new Date(initialDate);

//     // Generate recurring dates until the end date
//     while (current <= end) {
//       recurringDates.push(formatDate(current));
//       current = addDays(current, 7); // Add 7 days to get the next recurring date
//     }
//   });

//   return recurringDates;
// }

export function getRecurringDatesMonthly(props) {
  const { initialDates, endDate } = props
  // Convert endDate to a Date object
  const end = new Date(endDate);
  const recurringDates = [];

  // Helper function to add months to a date
  const addMonths = (date, months) => {
    const result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
  };

  // Helper function to format date as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Loop through each initial date
  initialDates.forEach((initialDate) => {
    let current = new Date(initialDate);

    // Generate recurring dates until the end date
    while (current <= end) {
      recurringDates.push(formatDate(current));
      current = addMonths(current, 1); // Add 1 month to get the next recurring date
    }
  });

  return recurringDates;
}

export function canDatesBeRecurring(dates, endDate, recurrence) {
  const intervals = {
    weekly: 7 * 24 * 60 * 60 * 1000, // 1 week in milliseconds
    monthly: 30 * 24 * 60 * 60 * 1000, // 1 month (approx) in milliseconds
    yearly: 365 * 24 * 60 * 60 * 1000 // 1 year in milliseconds
  };

  if (!intervals[recurrence]) {
    throw new Error("Invalid recurrence type. Valid types are 'weekly', 'monthly', or 'yearly'.");
  }

  const recurrenceInterval = intervals[recurrence];
  const endDateMs = new Date(endDate).getTime();

  for (let i = 0; i < dates.length; i++) {
    const dateMs = new Date(dates[i]).getTime();

    // Check if the date plus the recurrence interval is beyond the end date
    if (dateMs + recurrenceInterval > endDateMs) {
      return false;
    }
  }

  return true;
}

export function getRecurringDatesYearly(initialDates, endDate) {
  // Convert endDate to a Date object
  const end = new Date(endDate);
  const recurringDates = [];

  // Helper function to add years to a date
  const addYears = (date, years) => {
    const result = new Date(date);
    result.setFullYear(result.getFullYear() + years);
    return result;
  };

  // Helper function to format date as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Loop through each initial date
  initialDates.forEach((initialDate) => {
    let current = new Date(initialDate);

    // Generate recurring dates until the end date
    while (current <= end) {
      recurringDates.push(formatDate(current));
      current = addYears(current, 1); // Add 1 year to get the next recurring date
    }
  });

  return recurringDates;
}


function sortDates(dates) {
  return dates.sort((a, b) => moment(a).diff(moment(b)));
}

export const checkDateSpan = (props) => {
  const {
    dateArray: info,
    days = 7
  } = props

  const dateArray = sortDates(info)
  if (dateArray.length === 0) return false;

  let minDate = moment(dateArray[0]);
  let maxDate = moment(dateArray[dateArray?.length - 1]);

  dateArray.forEach(date => {
    const momentDate = moment(date);
    if (momentDate.isBefore(minDate)) {
      minDate = momentDate;
    }
    if (momentDate.isAfter(maxDate)) {
      maxDate = momentDate;
    }
  });

  const startOfWeek = minDate.startOf('week').format('YYYY-MM-DD');


  // Calculate the difference in days
  const diffDays = maxDate.diff(startOfWeek, 'days');
  // console.log("diffDays", dateArray, startOfWeek, maxDate, diffDays)
  // Check if the difference is greater than 7 days
  return diffDays > days;
};

export const getDatesNotInB = (props) => {
  const { arrayA, arrayB } = props
  // Convert arrayB to an array of moment objects
  const arrayBMoments = arrayB.map(date => moment(date));

  return arrayA.filter(dateA => {
    const momentA = moment(dateA);
    // Check if dateA is not in array B
    return !arrayBMoments.some(dateB => momentA.isSame(dateB, 'day'));
  });
};

export const getDateRange = (props) => {
  const { firstDate, lastDate } = props;
  if (
    moment(firstDate, "YYYY-MM-DD").isSame(
      moment(lastDate, "YYYY-MM-DD"),
      "day"
    )
  )
    return [lastDate];
  let date = firstDate;
  const dates = [date];
  do {
    date = moment(date).add(1, "day");
    dates.push(date.format("YYYY-MM-DD"));
  } while (moment(date).isBefore(lastDate));
  return dates?.map((date) => {
    return moment(date).format("MM/DD/YY");
  });
};


export function findDuplicateObjects(props) {
  const {
    arr,
    key
  } = props
  const frequencyCounter = {};
  const duplicates = [];

  for (const obj of arr) {
    const value = obj[key];
    if (frequencyCounter[value]) {
      frequencyCounter[value].count++;
      frequencyCounter[value].objects.push(obj);
    } else {
      frequencyCounter[value] = { count: 1, objects: [obj] };
    }
  }

  for (const value in frequencyCounter) {
    if (frequencyCounter[value].count > 1) {
      duplicates.push(...frequencyCounter[value].objects);
    }
  }

  return duplicates;
}

export function findDuplicates(props) {
  const {
    arr
  } = props
  const frequencyCounter = {};
  const duplicates = [];

  for (const element of arr) {
    if (frequencyCounter[element]) {
      frequencyCounter[element]++;
    } else {
      frequencyCounter[element] = 1;
    }
  }

  for (const element in frequencyCounter) {
    if (frequencyCounter[element] > 1) {
      duplicates.push(element);
    }
  }

  return duplicates;
}

export function combineDateArraysWithMoment(props) {
  const { array1, array2 } = props
  // Combine the two arrays
  const combined = [...array1, ...array2];

  // Use Moment to format and deduplicate dates
  const uniqueDates = [...new Set(combined.map(date => moment(date).format()))];

  // Sort the dates using Moment
  uniqueDates.sort((a, b) => moment(a).diff(moment(b)));

  // Convert back to Moment objects (or leave as strings if preferred)
  return uniqueDates.map(date => moment(date));
}

export function arrayToCommaSeparatedString(array) {
  if (!Array.isArray(array)) {
    return ''
  }
  return array.join(", ");
}

//  getDataWildArrayDB({
//       key: "data",
//       request: "wildsearchArray",
//       // searchVal: searchBy, //'04/15/24'  or {person:'E1', sleep:true},
//       searchVal: { person: 'E1', sleep: true },
//       resource: `${dataSource}_schedule`,
//       limit: itemsPerPage,
//       skip: itemsPerPage * currentPage,
//       orderBy: orderBy,
//       sortBy: sortHeaderBy || "person"
//     })

export async function getDataWildArrayDB(props) {
  const {
    query,
    key = "dates",
    request = "wildsearchArray",
    searchVal = "04/15/24",
    resource = `${dataSource}_schedule`,
    limit = 10000,
    skip,
    orderBy,
    sortBy,
    groupBy
  } = props;

  const formData = {
    request: request,
    query: query || {
      [key]: searchVal,
    },
    resource: resource,
    ...(skip ? { skip: skip } : {}),
    ...(limit ? { limit: limit } : {}),
    ...(orderBy ? { orderBy: orderBy } : {}),
    ...(sortBy ? { sortBy: sortBy } : {}),
    ...(groupBy ? { groupBy: groupBy } : {}),
  };

  // console.log('xxxxsformData', formData)

  return await RESTCall.axiosQuery(formData)
    .then((res) => {
      // console.log('xxxxsearchdata', res?.data)
      return res?.data;
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
}

export async function getDataNotNullDB(props) {
  const {
    request = "search",
    query,
    limit,
    skip,
    resource
  } = props

  const formData = {
    request,
    searchnotnull: true, //handle non null valls
    query: {
      ...query
    },
    resource,
    id: "",
    ...(limit ? { limit: 50, skip: skip || 0 } : {}),
  }
  return await RESTCall.axiosQuery(formData)
    .then(response => {
      // console.log('xxxxxhhhhxx', props, response)
      return response?.data
    })
    .catch(err => {
      console.log(err)
      return []
    })
}

export const processAndGroupData = (props) => {
  const {
    dataset = {
    }
  } = props
  const data = dataset.data;

  // Grouping by shift
  const shiftGroups = data.reduce((acc, item) => {
    if (!acc[item.shift]) acc[item.shift] = [];
    acc[item.shift].push(item);
    return acc;
  }, {});

  // Grouping by sleep attribute
  const sleepGroups = data.reduce((acc, item) => {
    const sleepKey = item.sleep ? "sleep" : "awake";
    if (!acc[sleepKey]) acc[sleepKey] = [];
    acc[sleepKey].push(item);
    return acc;
  }, {});

  // Grouping by facility
  const facilityGroups = data.reduce((acc, item) => {
    if (item.facility) {
      if (!acc[item.facility]) acc[item.facility] = [];
      acc[item.facility].push(item);
    }
    return acc;
  }, {});

  // Grouping by project
  const projectGroups = data.reduce((acc, item) => {
    if (item.project) {
      if (!acc[item.project]) acc[item.project] = [];
      acc[item.project].push(item);
    }
    return acc;
  }, {});

  // Grouping by person
  const personGroups = data.reduce((acc, item) => {
    if (item.person) {
      if (!acc[item.person]) acc[item.person] = [];
      acc[item.person].push(item);
    }
    return acc;
  }, {});

  // Grouping by sex
  const sexGroups = data.reduce((acc, item) => {
    if (item.sex) {
      if (!acc[item.sex]) acc[item.sex] = [];
      acc[item.sex].push(item);
    }
    return acc;
  }, {});

  // Adding new attributes to the main object
  dataset.groupedByShift = shiftGroups;
  dataset.groupedBySleep = sleepGroups;
  dataset.groupedByFacility = facilityGroups;
  dataset.groupedByProject = projectGroups;
  dataset.groupedByPerson = personGroups;
  dataset.groupedBySex = sexGroups;

  dataset.groupedByShiftCount = getCounts(shiftGroups)
  dataset.groupedBySleepCount = getCounts(sleepGroups)
  dataset.groupedByFacilityCount = getCounts(facilityGroups)
  dataset.groupedByProjectCount = getCounts(projectGroups)
  dataset.groupedByPersonCount = getCounts(personGroups)
  dataset.groupedBySexCount = getCounts(sexGroups)

  return dataset;
}

const getCounts = (item) => {
  return Object.keys(item)?.map(reg => {
    return {
      [reg]: item?.[reg]?.length
    }
  });
}

const sampleResult = {
  "groupedByShift": {
    "day": [
      { "shift": "day", "sleep": true, "bed": "Unit 2-1", "date": "11/16/24", "person": "E101", "sex": "male", "project": "Core Support" },
      { "shift": "day", "sleep": true, "bed": "Unit 2-3", "date": "11/16/24", "person": "E103", "sex": "male", "project": "Core" }
    ],
    "night": [
      { "shift": "night", "sleep": false, "bed": "Unit 2-2", "date": "11/16/24", "person": "E102", "sex": "female", "project": "Core" }
    ]
  },
  "groupedBySleep": {
    "sleep": [
      { "shift": "day", "sleep": true, "bed": "Unit 2-1", "date": "11/16/24", "person": "E101", "sex": "male", "project": "Core Support" },
      { "shift": "day", "sleep": true, "bed": "Unit 2-3", "date": "11/16/24", "person": "E103", "sex": "male", "project": "Core" }
    ],
    "awake": [
      { "shift": "night", "sleep": false, "bed": "Unit 2-2", "date": "11/16/24", "person": "E102", "sex": "female", "project": "Core" }
    ]
  },
  "groupedByFacility": {},
  "groupedByProject": {
    "Core Support": [
      { "shift": "day", "sleep": true, "bed": "Unit 2-1", "date": "11/16/24", "person": "E101", "sex": "male", "project": "Core Support" }
    ],
    "Core": [
      { "shift": "night", "sleep": false, "bed": "Unit 2-2", "date": "11/16/24", "person": "E102", "sex": "female", "project": "Core" },
      { "shift": "day", "sleep": true, "bed": "Unit 2-3", "date": "11/16/24", "person": "E103", "sex": "male", "project": "Core" }
    ]
  },
  "groupedByPerson": {
    "E101": [
      { "shift": "day", "sleep": true, "bed": "Unit 2-1", "date": "11/16/24", "person": "E101", "sex": "male", "project": "Core Support" }
    ],
    "E102": [
      { "shift": "night", "sleep": false, "bed": "Unit 2-2", "date": "11/16/24", "person": "E102", "sex": "female", "project": "Core" }
    ],
    "E103": [
      { "shift": "day", "sleep": true, "bed": "Unit 2-3", "date": "11/16/24", "person": "E103", "sex": "male", "project": "Core" }
    ]
  },
  "groupedBySex": {
    "male": [
      { "shift": "day", "sleep": true, "bed": "Unit 2-1", "date": "11/16/24", "person": "E101", "sex": "male", "project": "Core Support" },
      { "shift": "day", "sleep": true, "bed": "Unit 2-3", "date": "11/16/24", "person": "E103", "sex": "male", "project": "Core" }
    ],
    "female": [
      { "shift": "night", "sleep": false, "bed": "Unit 2-2", "date": "11/16/24", "person": "E102", "sex": "female", "project": "Core" }
    ]
  }
}


//getDataDB({ resource,query})
export async function getDataDB(props) {
  const {
    resource,
    query,
    skip,
    limit,
    orderBy,
    sortBy,
    groupBy,
    inrange
  } = props;

  if (!(resource && query)) {
    return;
  }
  const formData = {
    ...props,
    request: "search",
    query: {
      ...query,
    },
    ...(inrange ? { inrange: inrange } : {}),
    ...(skip ? { skip: skip } : {}),
    ...(limit ? { limit: limit } : {}),
    ...(orderBy ? { orderBy: orderBy } : {}),
    ...(sortBy ? { sortBy: sortBy } : {}),
    ...(groupBy ? { groupBy: groupBy } : {}),
    // check: ["handle", "fullName"],
    resource: resource,
    id: "",
  };

  // console.log('compsxxx', formData)

  return await RESTCall.axiosQuery(formData).then((response) => {
    return (response && response.data) || [];
  });
}

export function isValidDate(props) {
  const { dateString } = props
  // Check if the string is a valid date using moment's isValid() function
  return moment(dateString, moment.ISO_8601, true).isValid();
}

export const isDateBetween = (props) => {
  const {
    targetDate, startDate, endDate
  } = props
  const momentTargetDate = moment(targetDate)?.format("MM/DD/YY");
  const momentStartDate = moment(startDate)?.format("MM/DD/YY");
  const momentEndDate = moment(endDate)?.format("MM/DD/YY");

  if (!momentTargetDate.isValid() || !momentStartDate.isValid() || !momentEndDate.isValid()) {
    return false
  }

  return momentTargetDate.isBetween(momentStartDate, momentEndDate, undefined, '[]');
};

//----calendar_contacts
export async function deleteDataDB(props) {
  const { id, resource } = props;

  if (!(id && resource)) {
    return;
  }
  const formData = {
    request: "delete",
    query: {
      // ...search
    },
    // check: ["handle", "fullName"],
    resource: resource,
    id: id,
  };
  return await RESTCall.axiosQuery(formData).then((response) => {
    return (response && response.data) || [];
  });
}

export const sendNotification = async (campaign) => {
  const options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      Authorization: 'Basic OThjYjhhYmUtMzZiZC00OTJiLThjNzYtNWU3NzAzYWE2NDM0',
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      included_segments: ['Total Subscriptions'],
      contents: {
        en: 'Test message', //'English or Any Language Message', 
        es: 'Spanish Message'
      },
      // include_aliases: { "external_id": ["'@test"] },
      target_channel: "push",
      data: { url: 'https://main.d1lhqpcha4hxnw.amplifyapp.com/' },
      name: campaign, //'INTERNAL_CAMPAIGN_NAME',
      app_id: '2cc8f596-8070-43c1-a02f-db9f79335b12'
    })
  }
  // console.log('saved options ', options)

  fetch('https://onesignal.com/api/v1/notifications', options)
    .then(response => response.json())
    .then(response => console.log('response', response))
    .catch(err => console.error(err));

}


export const sendMyEmail = async ({
  name,
  email,
  eventInfo = {},
  data = {},
  calendarLink,
  location,
  tab,
  query = []
}) => {
  if (!email) {
    // alert('No email')
    return;
  }
  const emailObject = {
    to: email,
    subject: "Message from GuestNet Planner ✔", // Subject line
    text: "", // plain text body
    // email["html"] = text || `<b>${text?.toString()}</b>`; // html body
    html: `
<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>${"Action Event on your event"}</title>
</head>
<body style="margin: 0; padding: 0; background-color: #f4f4f4; font-family: Arial, sans-serif;">
<table align="center" border="0" cellpadding="0" cellspacing="0" width="600" style="border-collapse: collapse;">
<tr>
    <td align="center" bgcolor="#ffffff" style="padding: 40px 0 30px 0;">
        <img style="width: 350px" src=${eventInfo?.img ||
      eventInfo?.picture ||
      eventInfo?.iamge ||
      "https://varefiles.s3.us-east-2.amazonaws.com/meetingpic2.jpg"
      } alt="Event Logo"  />
    </td>
</tr>
<tr>
  <td bgcolor="#ffffff" style="padding: 40px 30px 40px 30px;">
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;">
      <tr>
        <td style="color: #153643; font-size: 24px; font-weight: bold; text-align: center;">
          Welcome to RMA Public School Enrollment!
        </td>
      </tr>
      <tr>
        <td style="padding: 20px 0 30px 0; color: #153643; font-size: 16px; line-height: 20px; text-align: center;">
          ${name} has just completed an enrollment action on your ${tab} page for the program: ${eventInfo?.title}.
        </td>
      </tr>
      <tr>
        <td align="center">
          <a href="${location}" style="font-size: 18px; font-weight: bold; color: #ffffff; text-decoration: none; background-color: #1a75ff; padding: 15px 25px; border-radius: 5px; display: inline-block;">
            View Enrollment Details
          </a>
        </td>
      </tr>
    </table>
  </td>
</tr>
<tr>

</tr>
</table>
</body>
</html>
`,
    query
  };
  // console.log("emailObject", emailObject);
  return sendEmail(emailObject);
};

const sendAllEmails = async ({ myInfo, eventInfo, resource, query }) => {
  // console.log(myInfo, 'sassas')
  if (!myInfo?.handle) {
    return;
  }
  // if (!(eventInfo?.handle && eventInfo?.handle == myInfo?.handle)) {
  //   return;
  // }
  await getDataDB({
    query: {
      handle: myInfo?.handle,
    },
    resource: "vare_user_education",
  }).then((info) => {
    // console.log("infosssss", info);
    const host = info?.[0];
    sendMyEmail({
      name: host?.name,
      email: host?.email,
      eventInfo,
      tab: resource?.split("_")?.[resource?.split("_")?.length - 1],
      location: `https://www.myguestnet.com/event/${resource}`,
      query: query
    });
  });

  await getDataDB({
    query: {
      handle: eventInfo?.handle,
    },
    resource: "vare_user_education",
  }).then((info) => {
    const host = info?.[0];
    sendMyEmail({
      name: host?.name,
      email: host?.email,
      eventInfo,
      tab: resource?.split("_")?.[resource?.split("_")?.length - 1],
      location: `https://www.myguestnet.com/event/${resource}`,
    });
  });
  // }
};

export async function saveEmailDB(props) {
  const {
    query = {},
    resource,
    check = ["eventId", "handle"],
    myInfo = {},
  } = props;

  const { eventInfo } = myInfo;

  // if (!myInfo?.handle) {
  //   alert("Please Login");
  //   return;
  // }

  // if (!resource) {
  //   alert("Missing resource");
  //   return;
  // }

  if (!Object.keys(query)?.[0]) {
    // alert("Missing query");
    return;
  }

  delete query?._id;
  const formData = {
    request: "insert",
    query: {
      ...query,
      handle: myInfo?.handle,
      date: moment().format(),
    },
    resource: `${dataSource}_email_records`,
    check,
  };
  return await RESTCall.axiosQuery(formData)
    .then((response) => {
      sendAllEmails({
        myInfo,
        eventInfo,
        resource,
      });

      return response;
    })
    .catch((error) => {
      return error;
    });
}

export async function getEmailDB(props) {
  const { query = {}, limit = 500, resource } = props;

  if (!resource) {
    // alert("Missing resource");
    return;
  }
  const formData = {
    request: "search",
    query: {
      ...query,
    },
    limit: limit,
    resource: `${dataSource}_email_records`,
    id: "",
  };
  return await RESTCall.axiosQuery(formData).then((response) => {
    return (response && response.data) || [];
  });
}

export const sendEmail = async (emailInfo) => {
  const { to, text, html, subject, location, myInfo, data, calendarLink, query } = emailInfo;
  // console.log(data, 'datatatat')
  const email = {
    to,
    text,
    html,
    subject,
  };
  if (!to) {
    return;
  }
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const finalImage = data?.img || data?.picture || "https://onguestnet.com/wp-content/uploads/2024/03/107217845-1680190995225-Hafnia3-013_small.jpeg"

  const extension = finalImage.split('.').pop();
  // email['from'] = from || '"VareTech" <member@vareapp.com>' // sender address
  email["to"] = to || to?.toString(); // list of receivers
  email["subject"] = subject ? subject : "Message from Hexagon ✔"; // Subject line
  email["text"] = text ? text : "Message from Hexagon ✔"; // plain text body
  // email["html"] = text || `<b>${text?.toString()}</b>`; // html body
  email["html"] = html
    ? html
    : `
  <!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>${"POB Schedule Creation Information"}</title>
</head>
<body style="margin: 0; padding: 0; background-color: #f4f4f4; font-family: Arial, sans-serif;">
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="600" style="border-collapse: collapse;">
        <tr>
            <td align="center" bgcolor="#ffffff" style="padding: 40px 0 30px 0;">
                <img style="width: 350px;"  src=${extension === ('jpg' || 'jpeg') ? finalImage : "https://onguestnet.com/wp-content/uploads/2024/03/107217845-1680190995225-Hafnia3-013_small.jpeg"
    } alt="Event Logo"/>
            </td>
        </tr>
        <tr>
            <td bgcolor="#ffffff" style="padding: 40px 30px 40px 30px;">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;">
                    <tr>
                        <td style="color: #153643; font-size: 24px; font-weight: bold; text-align: center;">
                            You're all set!
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 20px 0 30px 0; color: #153643; font-size: 16px; line-height: 20px; text-align: center;">
                            Your ${data?.name
    } POB Schedule was successfully processed! If you have any further questions, please contact the host.
                        </td>
                    </tr>
                    <tr>
                        <td align="center" style="">
                            <a href="${calendarLink}" style="font-size: 18px; margin-top:10px; font-weight: bold; color: #ffffff; text-decoration: none; background-color: #1a75ff; padding: 15px 25px; border-radius: 5px; display: inline-block;">
                                Add to Calendar
                            </a>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
        
        </tr>
    </table>
</body>
</html>
`;


  var raw = JSON.stringify(email);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  await fetch(
    `${"https://ytkpw57tnna3kbppvoqr4rwixa0kxkgv.lambda-url.us-east-2.on.aws"}/email`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      const data = {
        query: query,
        // resource: `calendar_event_advert_accept_package`,
        // check: ["handle", "eventId"],
        myInfo,
      };
      saveEmailDB(data)
      return result;
    })
    .catch((error) => console.log("error", error));
};

export async function getAttendanceDB(search) {
  if (!search) {
    return;
  }
  const formData = {
    request: "search",
    query: {
      ...search,
    },
    // check: ["handle", "fullName"],
    resource: "calendar_attendance",
    id: "",
  };
  return await RESTCall.axiosQuery(formData).then((response) => {
    return (response && response.data) || [];
  });
}



// export const getRecurringDates = (props) => {
//   const { start = "2018-11-07", end = "2018-12-01" } = props;
//   const moment = MomentRange.extendMoment(moment);
//   const range = moment.range(moment(start), moment(end));
//   console.log(Array.from(range.by("week")));
//   return Array.from(range.by("week"));
// };


export const relatedPict = [
  "https://images.pexels.com/photos/3246665/pexels-photo-3246665.jpeg",
  "https://images.pexels.com/photos/102127/pexels-photo-102127.jpeg",
  "https://images.pexels.com/photos/1193743/pexels-photo-1193743.jpeg",
  "https://images.pexels.com/photos/962312/pexels-photo-962312.jpeg",
  "https://images.pexels.com/photos/1585325/pexels-photo-1585325.jpeg",
  "https://images.pexels.com/photos/743986/pexels-photo-743986.jpeg",
  "https://images.pexels.com/photos/1646953/pexels-photo-1646953.jpeg",
  "https://images.pexels.com/photos/1570264/pexels-photo-1570264.jpeg",
  "https://images.pexels.com/photos/1209843/pexels-photo-1209843.jpeg",
  "https://images.pexels.com/photos/886521/pexels-photo-886521.jpeg",
  "https://images.pexels.com/photos/699466/pexels-photo-699466.jpeg",
  "https://images.pexels.com/photos/889839/pexels-photo-889839.jpeg",
  "https://images.pexels.com/photos/1762851/pexels-photo-1762851.jpeg",
  "https://images.pexels.com/photos/1572386/pexels-photo-1572386.jpeg",
  "https://images.pexels.com/photos/1918290/pexels-photo-1918290.jpeg",
  "https://images.pexels.com/photos/159862/pexels-photo-159862.jpeg",
  "https://images.pexels.com/photos/1170576/pexels-photo-1170576.jpeg",
  "https://images.pexels.com/photos/1183992/pexels-photo-1183992.jpeg",
  "https://images.pexels.com/photos/1145720/pexels-photo-1145720.jpeg",
  "https://images.pexels.com/photos/1568607/pexels-photo-1568607.jpeg",
  "https://images.pexels.com/photos/20967/pexels-photo-20967.jpeg",
  "https://images.pexels.com/photos/1109354/pexels-photo-1109354.jpeg",
  "https://images.pexels.com/photos/942317/pexels-photo-942317.jpeg",
  "https://images.pexels.com/photos/1616403/pexels-photo-1616403.jpeg",
  "https://images.pexels.com/photos/542556/pexels-photo-542556.jpeg",
  "https://images.pexels.com/photos/587958/pexels-photo-587958.jpeg",
  "https://images.pexels.com/photos/1037993/pexels-photo-1037993.jpeg",
  "https://images.pexels.com/photos/1194420/pexels-photo-1194420.jpeg",
  "https://images.pexels.com/photos/1081685/pexels-photo-1081685.jpeg",
  "https://images.pexels.com/photos/1939485/pexels-photo-1939485.jpeg",
  "https://images.pexels.com/photos/354939/pexels-photo-354939.jpeg",
  "https://images.pexels.com/photos/39348/pexels-photo-39348.jpeg",
  "https://images.pexels.com/photos/1047540/pexels-photo-1047540.jpeg",
  "https://images.pexels.com/photos/1690351/pexels-photo-1690351.jpeg",
  "https://images.pexels.com/photos/164455/pexels-photo-164455.jpeg",
  "https://images.pexels.com/photos/2832382/pexels-photo-2832382.jpeg",
  "https://images.pexels.com/photos/1477166/pexels-photo-1477166.jpeg",
  "https://images.pexels.com/photos/925743/pexels-photo-925743.jpeg",
  "https://images.pexels.com/photos/1292241/pexels-photo-1292241.jpeg",
  "https://images.pexels.com/photos/804269/pexels-photo-804269.jpeg",
  "https://images.pexels.com/photos/311458/pexels-photo-311458.jpeg",
  "https://images.pexels.com/photos/1629236/pexels-photo-1629236.jpeg",
  "https://images.pexels.com/photos/166277/pexels-photo-166277.jpeg",
  "https://images.pexels.com/photos/1084510/pexels-photo-1084510.jpeg",
  "https://images.pexels.com/photos/1266808/pexels-photo-1266808.jpeg",
  "https://images.pexels.com/photos/2086361/pexels-photo-2086361.jpeg",
  "https://images.pexels.com/photos/206064/pexels-photo-206064.jpeg",
  "https://images.pexels.com/photos/626163/pexels-photo-626163.jpeg",
  "https://images.pexels.com/photos/288099/pexels-photo-288099.jpeg",
  "https://images.pexels.com/photos/1109352/pexels-photo-1109352.jpeg",
];



export function getParamsFromUrl(url) {
  // Split the URL path by '/'
  const parts = url.split("/");

  // Filter out any empty strings from extra slashes
  const filteredParts = parts.filter(part => part !== "");

  // Return the path parts as an array
  return filteredParts;
}
//This is the production hexagon database
// export const dataSource = "hexagon_test";

export const filterByDateRange = (data, startDate, endDate) => {
  const start = moment(startDate, "MM/DD/YY").startOf("day");
  const end = moment(endDate, "MM/DD/YY").endOf("day");

  return data.filter((item) => {
    const itemDate = moment(item.date, "MM/DD/YY"); // Ensure item.date is in correct format
    return itemDate.isBetween(start, end, null, "[]"); // Inclusive comparison
  });
};

export const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
export const weekDaysAb = ["S", "M", "T", "W", "T", "F", "S"]


export const daysOfGivenWeek = (props) => {
  const {
    current,
  } = props
  if (!current) {
    return []
  }
  const startDay = current && moment(current).startOf('week')?.format('YYYY/MM/DD')
  // const endDay = moment('2024-1-12').endOf('week')?.format('YYYY/MM/DD')
  let i = 0;
  const myDays = []
  for (i = 0; i < 7; i++) {
    myDays.push(
      {
        date: moment(startDay).add(i, 'days')?.format('YYYY/MM/DD'),
        day: weekDays[i],
        dayAb: weekDaysAb[i]
      }
    )
  }
  return myDays;
}

